/* Copyright (c)2025 Sky Co., LTD. All rights reserved. */

/* 下記にC#用の同定義がございます。変更の際はそちらも対応し、差異の出ないようにしてください	*/
/* 		SCV/SaaS/Web/CtlSvr_Cloud/CtlSvr_Cloud/Models/MgrRestriction/MgrRestrictionDef.cs	*/
export class MgrRestrictionDef {
    // 資産管理
    public readonly AstPCLst = 0;  // ハードウェア一覧
    public readonly AstPCLst_PCLst = 1;	// ハードウェア一覧 端末一覧
    public readonly AstPCLst_Edit = 2;  // ハードウェア一覧 端末一覧 編集（インポート/端末情報の編集/部署移動/アラート状態解除）
    public readonly AstPCLst_Delete = 3;  // ハードウェア一覧 端末一覧 端末削除
    public readonly AstPCLst_Uninstall = 4;  // ハードウェア一覧 端末一覧 アンインストール許可
    public readonly AstPCLst_Mobile = 5;  // ハードウェア一覧 モバイル端末登録
    public readonly AstPCLst_Mobile_ADE = 6;  // ハードウェア一覧 モバイル端末登録 ADEプロファイルの編集（全部署共通設定）
    public readonly AstPCLst_Mobile_iOS_Data = 7;  // ハードウェア一覧 モバイル端末登録 モバイル端末(iOS)のデータ取得
    public readonly AstPCLst_Mobile_Control = 8;  // ハードウェア一覧 モバイル端末登録 モバイル端末制御
    public readonly AstPCLst_Rcv = 9;  // ハードウェア一覧 リモート操作
    public readonly AstPCLst_MDMSet = 10;  // ハードウェア一覧 紛失端末制御
    public readonly BitLocker = 11;  // ハードウェア一覧 BitLocker情報確認
    public readonly MDMSetWeb = 12;  // ハードウェア一覧 紛失端末制御状況
    public readonly AstAPInf = 13;  // アプリケーション一覧
    public readonly AstAPInf_OfficeSetup = 14;  // アプリケーション一覧 Office
    public readonly AstAPInf_VirusChecker = 15;  // アプリケーション一覧 ウイルス対策ソフト
    public readonly AstAPInf_AppSetup = 16;  // アプリケーション一覧 アプリケーション
    public readonly AstAPInf_WinStoreApp = 17;  // アプリケーション一覧 Windowsストアアプリ
    public readonly AstAPInf_OSLicense = 18;  // アプリケーション一覧 OS
    public readonly AstAPInf_WinPatch = 19;  // アプリケーション一覧 Windows更新
    public readonly AstAPInf_Software = 20;  // アプリケーション一覧 ソフトウェア配布
    public readonly AstAPInf_Software_Edit = 21;  // アプリケーション一覧 ソフトウェア配布 編集（ソフトウェア 追加/編集/削除）
    public readonly AstAPInf_MobileApp = 22;  // アプリケーション一覧 モバイルアプリ
    public readonly AstAPInf_MobileEMMDistributeApp = 23;  // アプリケーション一覧 iOSアプリ管理
    public readonly AstAPInf_MobileEMM_iOS_OSUpdate = 24;  // アプリケーション一覧 iOSアップデート
    public readonly AstAPInf_MobileEMM_Android_APPMng = 25;  // アプリケーション一覧 Androidアプリ管理
    public readonly USBDevSet = 26;  // デバイス管理
    public readonly USBDevSet_RegUsbDev = 27;  // デバイス管理 USBデバイス登録
    public readonly USBDevSet_Media_Manage_List_DeviceAlertSet = 28;  // デバイス管理 デバイス種別制御設定／アラート設定
    public readonly USBDevSet_Common = 29;  // デバイス管理 共通設定

    // ログ管理
    public readonly LGB = 30;  // ログ閲覧
    public readonly LGB_AgLogonoff = 31;  // ログ閲覧 起動・終了
    public readonly LGB_Application = 32;  // ログ閲覧 アプリケーション
    public readonly LGB_FileOperation = 33;  // ログ閲覧 ファイル操作
    public readonly LGB_System = 34;  // ログ閲覧 システム
    public readonly LGB_Printer = 35;  // ログ閲覧 プリント
    public readonly LGB_WebDownload = 36;  // ログ閲覧 Webアクセス
    public readonly LGB_Removable = 37;  // ログ閲覧 ドライブ
    public readonly EMMLocationInfoMng = 38;  // 位置情報管理

    // 設定
    public readonly AltSet = 39;  // アラート設定
    public readonly AltSet_Ast = 40;  // アラート設定 資産アラート
    public readonly AltSet_Application = 41;  // アラート設定 アプリケーションアラート
    public readonly AltSet_File = 42;  // アラート設定 ファイル操作アラート
    public readonly AltSet_Other = 43;  // アラート設定 その他アラート
    public readonly AstSet = 44;  // 資産設定
    public readonly AstSet_Division = 45;  // 資産設定 部署別設定
    public readonly AstSet_Common = 46;  // 資産設定 共通設定
    public readonly LogSet = 47;  // ログ設定
    public readonly LogSet_Normal = 48;  // ログ設定 通常ログ設定
    public readonly LogSet_DataServer = 49;  // ログ設定 データサーバー設定
    public readonly OprSet = 50;  // 運用設定
    public readonly OprSet_Common = 51;  // 運用設定 共通設定
    public readonly OprSet_Common_Division = 52;  // 運用設定 共通設定 部署一覧の編集
    public readonly OprSet_Common_Dashboard = 53;  // 運用設定 共通設定 ダッシュボード設定
    public readonly OprSet_Download = 54;  // 運用設定 ダウンロード
    public readonly OprSet_Download_Agent = 55;  // 運用設定 ダウンロード SKYSEA端末機のインストーラー/アンインストーラー
    public readonly OprSet_Download_Remote = 56;  // 運用設定 ダウンロード 利用者側操作PC（SKYDIV）リモートアクセスサービス）のインストーラー/アンインストーラー
    public readonly MDMSet = 57;  // 紛失端末制御設定
    public readonly MDMSet_Division = 58;  // 紛失端末制御設定 部署別設定
    public readonly MDMSet_Common = 59;  // 紛失端末制御設定 共通設定
    public readonly CsvExp = 60;  // ログ一括出力
    public readonly MBLSET = 61;  // モバイル設定
    public readonly MBLSET_iOS = 62;  // モバイル設定 iOS用設定
    public readonly MBLSET_iOS_Alt = 63;  // モバイル設定 iOS用設定 アラート設定
    public readonly MBLSET_iOS_EMM_Profile = 64;  // モバイル設定 iOS用設定 構成プロファイル設定
    public readonly MBLSET_iOS_EMM_Profile_Common = 65;  // モバイル設定 iOS用設定 参照用構成プロファイル（全部署共通設定）
    public readonly MBLSET_iOS_Ast = 66;  // モバイル設定 iOS用設定 資産設定
    public readonly MBLSET_iOS_VPP = 67;  // モバイル設定 iOS用設定 VPP設定
    public readonly MBLSET_iOS_Common = 68;  // モバイル設定 iOS用設定 共通設定
    public readonly MBLSET_Android = 69;  // モバイル設定 Android設定
    public readonly MBLSET_Android_EMM_Policy = 70;  // モバイル設定 Android設定 MDMポリシー設定
    public readonly MBLSET_Android_Common = 71;  // モバイル設定 Android設定 共通設定

    // その他
    public readonly LicenseInfo = 72;  // ライセンス情報

    // ADD 21.00 電子書籍配布対応
    public readonly AstAPInf_MobileEMM_iOS_DistributeBook = 73;  // アプリケーション一覧 iOSブック配布
    // ADD 21.00 新規ログ種別対応
    public readonly LGB_ActWnd = 74;	// ログ閲覧 クライアント操作
    public readonly LGB_NetDevice = 75;	// ログ閲覧 通信デバイス
    public readonly LGB_SendMail = 76;	// ログ閲覧 メール
    // ADD 21.00 アラートの管理者メール通知
    public readonly AltSet_Common = 77;  // アラート設定 共通設定
    // ADD 21.00 資産管理限定版
    public readonly LGB_PCUtilizeAnalysis = 78; // PC活用状況分析
    // ADD 21.00 Windows更新制御
    public readonly WinUpdSet = 79;  // Windows更新制御設定
    // ADD 21.00 生成AI機能－QAチャット対応
	public readonly AIAdvisor = 80;  // AIアドバイザー
    // ADD 21.20 PC環境診断
    public readonly PcConditionCheck = 81;  // PC環境診断
    // ADD 21.20 メッセージ
    public readonly Message = 82;  // メッセージ
    public readonly Message_Mng = 83; // メッセージ管理
    public readonly Message_Common = 84; // メッセージ 共通設定
    // ADD 21.20 アンケート
    public readonly Enquete = 85;  // アンケート管理
    public readonly Enquete_Mng = 86;  // アンケート管理
    public readonly Enquete_Common = 87; // アンケート 共通設定
    // ADD 21.20 PC環境診断
    public readonly PcConditionCheck_Setting = 88;  // PC環境診断 設定
    // ADD 21.30 不許可端末検知
    public readonly LGB_IllegalTerminal = 89;  // ログ閲覧 不許可端末
    // ADD 22.00 Windows更新管理（品質更新プログラム管理）
    public readonly Wud = 90;  // 更新プログラム配布管理
    public readonly Wud_Mng = 91;  // 更新プログラム配布管理 更新プログラム配布管理
    public readonly Wud_Division = 92;  // 更新プログラム配布管理 部署別設定
    public readonly Wud_Common = 93;  // 更新プログラム配布管理 共通設定
    // ADD 22.00 組織内マルウェア情報
    public readonly MalwareInfo = 94  // 組織内マルウェア情報

    public readonly MgrRestrictionMax = 95;  // 総数（↑新規追加の際はこれより上に追記し、この値を更新してください）
}

/* Copyright (c)2025 Sky Co., LTD. All rights reserved. */
